import {
    buildSitemapIndex,
    buildUrlSet,
    STATIC_SITEMAP_PATHS,
    sitemapResponse,
} from "./sitemap";
export const sitemapIndexRoute = {
    server: {
        handlers: {
            GET: async () => {
                const { getListingSitemapPageCount } =
                    await import("./sitemap-query");
                return sitemapResponse(
                    buildSitemapIndex(await getListingSitemapPageCount()),
                );
            },
        },
    },
};

export const listingSitemapRoute = {
    server: {
        handlers: {
            GET: async ({ params }: { params: { page: string } }) => {
                const { getListingSitemapPage } =
                    await import("./sitemap-query");
                const page = Number(params.page);
                if (!Number.isSafeInteger(page) || page < 1) {
                    return new Response("Not found", { status: 404 });
                }

                const listings = await getListingSitemapPage(page);
                if (listings.length === 0) {
                    return new Response("Not found", { status: 404 });
                }

                return sitemapResponse(
                    buildUrlSet(
                        listings.map(({ id, updatedAt }) => ({
                            path: `/dog/${encodeURIComponent(id)}`,
                            lastModified: updatedAt,
                        })),
                    ),
                );
            },
        },
    },
};

export const staticSitemapRoute = {
    server: {
        handlers: {
            GET: () =>
                sitemapResponse(
                    buildUrlSet(STATIC_SITEMAP_PATHS.map((path) => ({ path }))),
                ),
        },
    },
};
